import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessTakeoverEmployeeQuery } from '@/__generated__/businessTakeoverEmployeeQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { TakeoverEmployeeContainer } from '@/components/survey/business/takeover-employee/TakeoverEmployeeContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { takeoverEmployeeQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function TakeoverEmployeePage() {
  const eventAttributes = useSurveyUserEventAttributes();
  const [queryRef, loadQuery] = useQueryLoader<businessTakeoverEmployeeQuery>(takeoverEmployeeQuery);

  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);

  useEffect(() => {
    if (refundHistoryId && bmanTin) {
      loadQuery(
        {
          bmanTin,
          refundHistoryId
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [loadQuery, refundHistoryId, bmanTin]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_takeover-employee'} eventProperty={eventAttributes}>
      <TakeoverEmployeeContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

TakeoverEmployeePage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default TakeoverEmployeePage;
